import { Collect } from '@sorare/core/src/atoms/icons/Collect';
import { HalfCircularProgressBar } from '@sorare/core/src/atoms/loader/CircularProgressIndicator/HalfCircularProgressBar/index.tsx';
import type { WidgetChipState } from '@sorare/core/src/atoms/ui/Chip/WidgetChip/index.tsx';
import { Orb } from '@sorare/core/src/components/Orb';
import type { Unit } from '@sorare/core/src/lib/style.ts';

import { IconWrapper } from '#src/components/series/SeriesMissions/ui.tsx';

type Props = {
  chipState?: WidgetChipState;
  size?: Unit;
  progresses: number[];
} & ({ to: string; onClick?: never } | { onClick: () => void; to?: never });

export const DumbFeaturedCollectionTaskWidget = ({
  chipState,
  size = 5,
  progresses,
  ...rest
}: Props) => (
  <Orb
    color="var(--c-inventory-orange)"
    size={size}
    chipState={chipState}
    {...rest}
  >
    <HalfCircularProgressBar
      size={size}
      progresses={progresses}
      colors={[
        {
          from: 'var(--c-inventory-yellow)',
          to: 'var(--c-inventory-orange)',
        },
      ]}
    />
    <IconWrapper>
      <Collect
        size={(size - 2) as Unit}
        colors={['var(--c-inventory-yellow)', 'var(--c-inventory-orange)']}
      />
    </IconWrapper>
  </Orb>
);
